import React from "react";
import styles from "./RuleText.module.css";
const RuleText = ({isDone=false,text}) => {
  return <li className={isDone ? styles.ruleDone : styles.ruleTodo}>{text}</li>;
};

export { RuleText };
